import { f_rules } from './commonUtils'
// import _ from 'lodash'
export const ConfigMixin = {
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            rules: f_rules,
            valid: false,
            config_data: {},
            o_data: {}
        }
    },
    async beforeMount() {
        console.log('CONFIG MIXIN DATA', this.data);
        if (!!this.data.block.conf) {
            console.log("$$ data block conf")
            this.o_data = _.cloneDeep(this.data.block.conf)
        } else {
            console.log("$$ init custom")
            await this.initCustomData()
        }
        this.restore()
    },
    methods: {
        handleSave() {
            console.log('emit updateBlock')
            this.$parent.$emit('updateBlock', { b_idx: this.data.index, b_id: this.data.block._id, conf: this.config_data })
        },
        restore() {
            this.config_data = _.cloneDeep(this.o_data)
        },
        getData(){
            return this.config_data
        },
        getValid(){
            return this.valid
        },
        initCustomData() {}
    },
    watch: {
        valid() {
            this.$parent.$emit('updateValidity', { b_idx: this.data.index, b_id: this.data.block._id, valid: this.valid })
        }
    }
}